<template>
  <div class="servicesComCon">
    <div class="text">包括车辆意外事故损失、呼叫中心服务、平台协助处理事故服务、维修及保养服务、人工服务等服务内容的费用。车辆损失小于1500元（含1500元）的损失金额由客户自行承担，车辆损失大于1500元的，客户仅需承担1500元；第三者责任险20万-100万元；司机险1万-10万元。具体保障范围范围如下：</div>
    <div class="tebalItem">
      <div class="serviceSubTitle">· 车辆损失险</div>
      <div class="tabelTitle">
        <div class="item item1"><p>保额</p></div>
        <div class="item item2"><p>保障范围</p></div>
        <div class="item item3"><p>客户承担</p></div>
        <div class="item item4"><p>保险公司及大方租车承担</p></div>
      </div>
      <div class="tabelBody">
        <div class="item item1"><p>车辆实际价值</p></div>
        <div class="item item2"><p>由于发生自然灾害（地震除外）、意外事故、其他保险事故导致的车辆本身的损失</p></div>
        <div class="item item3"><p>车辆定损金额1500元内事故全部承担；车辆定损金额8000元内事故，承担1500元；车辆定损金额8000元以上事故，承担1500元和车损总额20%的加速折旧费用。</p></div>
        <div class="item item4"><p>客户承担费用以外的部分</p></div>
      </div>
    </div>
    <div class="tebalItem">
      <div class="serviceSubTitle">· 第三者责任险</div>
      <div class="tabelTitle">
        <div class="item item1"><p>保额</p></div>
        <div class="item item2"><p>保障范围</p></div>
        <div class="item item3"><p>客户承担</p></div>
        <div class="item item4"><p>保险公司及大方租车承担</p></div>
      </div>
      <div class="tabelBody">
        <div class="item item1"><p>20万-100万</p></div>
        <div class="item item2"><p>保险车辆发生意外事故，导致第三者承受的损失</p></div>
        <div class="item item3"><p>因事故造成的换件与物损折旧残值费用</p></div>
        <div class="item item4"><p>因事故造成的换件与物损折旧残值费用以外部分的100%</p></div>
      </div>
    </div>
    <div class="tebalItem">
      <div class="serviceSubTitle">· 司机险</div>
      <div class="tabelTitle">
        <div class="item item1"><p>保额</p></div>
        <div class="item item2"><p>保障范围</p></div>
        <div class="item item3"><p>客户承担</p></div>
        <div class="item item4"><p>保险公司及大方租车承担</p></div>
      </div>
      <div class="tabelBody">
        <div class="item item1"><p>1万-10万</p></div>
        <div class="item item2"><p>车辆发生事故，致使驾驶员遭受人身伤亡或财产损失</p></div>
        <div class="item item3"><p>0</p></div>
        <div class="item item4"><p>100%</p></div>
      </div>
    </div>
    <div class="tebalItem">
      <div class="serviceSubTitle">· 不在保障范围内</div>
      <div class="text">1、无事故证明、无保险理赔资料；</div>
      <div class="text">2、以下情况产生的损失由用户自行承担：轮胎（含轮毂）损坏、底盘损坏、锁芯损坏；以及车牌、车衣等非车辆本身的设备或物料的遗失与损坏；</div>
      <div class="text">3、车辆租赁期间涉水事故损失，不在保险理赔范围内的费用；</div>
      <div class="text">4、因车损产生的停运损失费、折旧费；</div>
      <div class="text">5、其他基本保障服务中保险公司无需承担，或责任免除的费用。</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'securityServices'
  }
</script>
<style lang="scss" scoped type="text/scss">
  .servicesComCon {
    /*box-sizing: border-box;*/
    font-size: 22px;
    line-height: 28px;
    /*width: 100%;*/
    padding: 20px 40px;
    .text {
      text-indent: 20px;
    }
    .tebalItem {
      margin-top: 10px;
      .serviceSubTitle {
        margin-top: 10px;
        font-size: 22px;
        line-height: 40px;
      }
      .tabelTitle, .tabelBody {
        width: 100%;
        display: flex;
      }
      .tabelTitle {
        background-color: #f2f2f2;
        border: 1px solid #333; /*no*/
        .item1 {
          border-left: none;
        }
      }
      .tabelBody {
        border: 1px solid #333; /*no*/
        border-top: none;
        .item {
          padding: 10px 0;
        }
        .item1 {
          border-left: none;
        }
      }
      .item {
        border-left: 1px solid #333; /*no*/
        display: flex;
        align-items: center;
        p {
          display: block;
          text-align: center;
          width: 100%;
        }
      }
      .item1 { width: 15%; }
      .item2 { width: 45%; }
      .item3 { width: 25%; }
      .item4 { width: 15%; }
    }
    .tebalItem:first-child {
      margin-top: 0;
    }
  }
</style>
